<template>
  <Loader v-if="this.$store.state.isLoading" />
  <div class="row auth-row">
    <div class="col-12 col-lg-5 form-col">
      <router-link class="auth-logo" to="/">VueBlog</router-link>
      <p class="auth-already">
        Don't have an account?
        <span><router-link to="/register"> Register </router-link> </span>
      </p>
      <form @submit.prevent="login">
        <p class="auth-header">Login to VueBlog</p>
        <div class="auth-field">
          <i class="fas fa-envelope auth-icon"></i>
          <input
            type="email"
            class="auth-input"
            placeholder="Email"
            v-model="email"
          />
        </div>
        <div class="auth-field">
          <i class="fas fa-unlock auth-icon"></i>
          <input
            type="password"
            class="auth-input"
            placeholder="Password"
            v-model="password"
          />
        </div>
        <p style="color: red" v-if="errorMessage != ''">{{ errorMessage }}</p>
        <button type="submit" class="auth-button">Login</button>
      </form>
      <p class="mt-5">
        Forget your password?
        <span class="auth-forget"
          ><router-link to="/reset-password"> Reset </router-link>
        </span>
      </p>
    </div>
    <div class="col-7 background-section"></div>
  </div>
</template>


<script>
import firebase from "firebase/app";
import "firebase/auth";
import Loader from "../components/Loader.vue";

export default {
  name: "Login",
  components: {
    Loader,
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async login() {
      this.$store.commit("setIsLoading", true);
      try {
        const user = await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
        this.$store.dispatch("fetchUserProfile");
        this.$router.push("/");
      } catch (error) {
        this.errorMessage = error.message;
        console.log(error);
      } finally {
        this.$store.commit("setIsLoading", false);
      }
    },
  },
};
</script>


<style>
.auth-row {
  margin: 0;
  text-align: center;
  min-height: 100vh;
  max-width: 100vw;
  align-items: center;
}
.auth-logo {
  text-align: center;
  font-size: 40px;
  color: #95c7c4;
  margin-bottom: 40px;
  font-weight: bold;
}
.auth-logo:hover {
  text-decoration: none;
  color: #95c7c4 !important;
}
.auth-button {
  transition: all 0.5s ease;
  cursor: pointer;
  margin-top: 24px;
  padding: 12px 30px;
  background-color: #303030;
  color: #fff;
  border-radius: 20px;
  text-transform: uppercase;
  border: none !important;
  outline: none !important;
}
.auth-button:hover {
  background-color: rgba(48, 48, 48, 0.7);
}
.auth-icon {
  font-size: 18px;
  color: #555;
}
.auth-input {
  width: 100%;
  border: none;
  background-color: #f2f7f6;
  padding: 4px 4px 4px 30px;
  height: 50px;
  margin-left: 10px;
  border-radius: 10px;
  font-size: 16px;
}
.auth-input:focus {
  outline: none;
}
.auth-field {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.auth-forget {
  text-decoration: none;
  color: #000;
  cursor: pointer;
  font-size: 14px;
  margin: 16px 0px;
  border-bottom: 1px solid transparent;
  transition: all 0.5s ease;
}
.auth-forget:hover {
  border-color: #303030;
}
.auth-header {
  text-align: center;
  font-size: 30px;
  color: #303030;
  margin-bottom: 40px;
  font-weight: bold;
}
.form-col {
  justify-content: center;
  padding: 0 40px;
}
.auth-already {
  text-decoration: none;
  color: #000;
  font-size: 14px;
  margin: 16px 0px;
}
.horizontal-section {
  position: absolute;
  background-color: #fff;
  transform: rotate(3deg);
  width: 60px;
  right: -30px;
  height: 101%;
  display: initial;
}
.background-section {
  background-image: url("../assets/background/bg5.jpg");
  background-position: top right;
  height: 100vh; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}

@media (max-width: 991px) {
  .background-section {
    display: none;
  }
}

@media only screen and (min-width: 600px) and (max-width: 991px) {
  .form-col {
    padding: 0 120px;
  }
}

@media (min-width: 1400px) {
  .form-col {
    padding: 0 80px;
  }
}
@media (min-width: 1600px) {
  .form-col {
    padding: 0 120px;
  }
}
</style>